"use client"

import { ComponentConfig } from "@measured/puck"
import { configs, DefaultImage } from "../../../../external-components"

export type ImageGridProps = {
  items: {
    id?: number
    image?: string
    text1?: string
    text2?: string
  }[]
  height?: number
}

export const RenderConfig: ComponentConfig<ImageGridProps> = {
  render: ({ items }: { items: ImageGridProps["items"] }) => {
    return (
      <div className="w-[1155px] max-sm:w-full">
        <div className="grid grid-cols-5 md:grid-cols-5 mt-[80px] max-sm:grid-cols-2 max-sm:mt-[70px] max-sm:gap-[15px]">
          {items.map((item, index) => (
            <div
              key={index}
              className="relative w-[calc(100% / 5 - 15px)] mr-[15px] mb-[50px] flex flex-col justify-center items-center max-sm:mb-[35px] max-sm:mr-0"
            >
              <img
                className="w-[80px]"
                src={item.image ? `${configs.API_URL}${item.image}` : DefaultImage}
                alt={`imageCustomer ${index}`}
              />
              <p className="text-center max-sm:text-[13px]">
                {item.text1} <br /> {item.text2}{" "}
              </p>
            </div>
          ))}
        </div>
      </div>
    )
  },
}
